import {Toast} from 'vant';
import './index.styl'
window.$toast = Toast
export default Toast;
//使用方法　https://www.youzanyun.com/zanui/vant#/zh-CN/component/toast



// WEBPACK FOOTER //
// ./src/components/Popups/Toast/index.js